import type { FaireProductEntity } from "../../entity_types/product";

export const p_8tytmakn33: FaireProductEntity = {
  token: "p_8tytmakn33",
  type: "product",
  name: "Singing Bowl Set of 3 for Meditation and Mindfulness",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/d9b243df46a87dfd563f65c17e6b040f93fce87def3584a519e4b95b49b7a6e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b59acd5770814b3217ab3d462cee2a990d6dd7d23a03f1007d299d5144ec7abb.jpeg",
    "https://cdn.faire.com/fastly/3dc4707ec9081e725c1f44dffe7725c628fb631c001167775c6333546262f5a9.jpeg",
    "https://cdn.faire.com/fastly/5dfa378c8d8db949d551e382d82b685715c3a0429a8b1e6d2389fcf4cca1810b.jpeg",
    "https://cdn.faire.com/fastly/01ae0873666fb96f54f74b183dbac5d8260c7792d5160fc1a50759de9214581f.jpeg",
    "https://cdn.faire.com/fastly/76fff377b9bd6472653930db1aa10de7178afad0bc44fa18ad0eb0477900f89b.jpeg",
    "https://cdn.faire.com/fastly/89800898155cf7a8da2d15e07d9148acb987a91c80b3120bf88854aeae3cafec.jpeg",
    "https://cdn.faire.com/fastly/692677f3df4a90b8a7ba1b86585b15b1fa1ddc5dc1826a575763fed19e67dfe6.jpeg",
    "https://cdn.faire.com/fastly/687ad01c835877cdfe2f1a495d7af96e0d6100517e5bcd736fa8f3b2de3e1f23.jpeg",
    "https://cdn.faire.com/fastly/844de39ac239c89303d4f5f186d51189dc452ed0ac91567af4697e32715424d5.jpeg",
  ],
  priceDollars: 62.36,
  description:
    "Meet our singing bowl family set. including two of our bestselling singing bowls, this set is sure to optimize your meditation experience.\n\nHelpful details:\nSinging bowl diameters: 3 inch, 3.7 inch, 4 inch\nIdeal for meditation, relaxation, yoga, sound therapy, or even to use in classrooms\nScroll down to read about the health benefits of singing bowls!\n\nComes with three singing bowls, three mallets, and if you choose, three cushions!\n\nYou will get three cushions but only in two sizes. The 3.7-inch and the 4-inch can use the same cushion!",
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:25.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
